import { CampaignDoc } from "../../services/campaign.service";

export type CampaignDateField = "createdAt" | "scheduledAt";

export interface CampaignListFilterValues {
  search: string;
  status: string;
  dateField: CampaignDateField;
  dateFrom: string;
  dateTo: string;
}

const localDayBoundary = (value: string, endOfDay: boolean) => {
  if (!value) return null;
  const date = new Date(`${value}T${endOfDay ? "23:59:59.999" : "00:00:00"}`);
  return Number.isNaN(date.getTime()) ? null : date.getTime();
};

export const filterCampaignList = (
  campaigns: CampaignDoc[],
  filters: CampaignListFilterValues,
) => {
  const query = filters.search.trim().toLowerCase();
  const from = localDayBoundary(filters.dateFrom, false);
  const to = localDayBoundary(filters.dateTo, true);

  return campaigns.filter((campaign) => {
    if (query && !campaign.name.toLowerCase().includes(query)) return false;
    if (filters.status && String(campaign.status).toUpperCase() !== filters.status) return false;

    if (from !== null || to !== null) {
      const rawDate = campaign[filters.dateField];
      if (!rawDate) return false;
      const timestamp = new Date(rawDate).getTime();
      if (Number.isNaN(timestamp)) return false;
      if (from !== null && timestamp < from) return false;
      if (to !== null && timestamp > to) return false;
    }

    return true;
  });
};
